/* eslint-disable indent */
/* eslint-disable no-cond-assign */
/* exported checkBrowsers, getCookie, setCookie */
function checkBrowsers() {
    var brower;
    var Sys = {};
    var ua = navigator.userAgent.toLowerCase();
    var s;
    (s = ua.match(/msie ([\d.]+)/)) ? Sys.ie = s[1] : (s = ua
            .match(/firefox\/([\d.]+)/)) ? Sys.firefox = s[1] : (s = ua
            .match(/chrome\/([\d.]+)/)) ? Sys.chrome = s[1] : (s = ua
            .match(/opera.([\d.]+)/)) ? Sys.opera = s[1] : (s = ua
            .match(/version\/([\d.]+).*safari/)) ? Sys.safari = s[1] : 0;
    if (Sys.ie) {
        brower = "ie" + Sys.ie;
    } else if (Sys.firefox) {
        brower = "firefox";
    } else if (Sys.chrome) {
        brower = "chrome" + Sys.chrome;
    } else if (Sys.opera) {
        brower = "opera" + Sys.opera;
    } else if (Sys.safari) {
        brower = "safari" + Sys.safari;
    } else { // for ie 11 workaround
        brower = "ie" + 11;
    }
    return brower;
}
function getCookie(c_name) {
    var i, x, y, ARRcookies = document.cookie.split(";");
    for (i = 0; i < ARRcookies.length; i++) {
        x = ARRcookies[i].substr(0, ARRcookies[i].indexOf("="));
        y = ARRcookies[i].substr(ARRcookies[i].indexOf("=") + 1);
        x = x.replace(/^\s+|\s+$/g, "");
        if (x == c_name) {
            return unescape(y);
        }
    }
}

function setCookie(c_name, value, exdays) {
    var exdate = new Date();
    exdate.setDate(exdate.getDate() + exdays);
    var c_value = escape(value)
            + ((exdays == null) ? "" : "; expires=" + exdate.toUTCString());
    document.cookie = c_name + "=" + c_value;
}